<div class="pane-content" [ngStyle]="{'max-width': gridContainerWidth ? gridContainerWidth+'px' : ''}">
  <div class="card" [ngClass]="{'mt-2': isDialog}">
    <!-- header -->
    <div class="card-header">
      <div class="row align-items-center">
        <div class="m-2">
          <div [className]="task.priorityBadgeClass">{{task.priority.charAt(0)}}</div>
        </div>
        <div class="col-sm-4 my-auto pl-0">
          <h3 title="{{fullTaskName}}" class="ellipsis-text-2 mr-2">{{fullTaskName}}</h3>
        </div>
        <!-- member info (if any) -->
        <ng-container *ngIf="member">
          <div class="col-sm-2 pl-0">
            <div class="row">
              <div class="col text-left p-0">
                <a class=" montserrat font-weight-bold" [ngClass]="{'pointer': isTaskListContext()}"
                  style="color: #f5f6fb" (click)="openMember(member.id)">{{member?.name?.fullName}}
                </a>
              </div>
            </div>
            <div class="row montserrat" *ngIf="member.mrn" style="font-size:smaller">
              {{'CHANNELS-RECORD-NUMBER' | translate }}: <br /> {{member.mrn}}
            </div>
          </div>
          <div class="col-sm-2 pl-0">
            <div class="row montserrat" *ngIf="member.dateOfBirth">
              <div class="col-12 text-left pl-0">
                {{member.dateOfBirth | date}} ({{'AGE' | translate}} {{member.age}})
              </div>
            </div>
            <div class="row montserrat" *ngIf="member.gender">
              <div class="col-12 text-left pl-0">
                {{member.gender.displayName}}
              </div>
            </div>
          </div>
          <div class="col-sm-3 pl-0" *ngIf="member.contact; let memberContactInfo">
            <div class="row montserrat">
              <div class="col-10">
                <div class="row" *ngIf="memberContactInfo.homePhoneNumber">
                  <div class="col-5 text-right">
                    {{ 'HOME' | translate}}:
                  </div>
                  <div class="col-7 text-left pl-0">
                    {{memberContactInfo.homePhoneNumber | phone}}
                  </div>
                </div>
                <div class="row" *ngIf="memberContactInfo.cellPhoneNumber">
                  <div class="col-5 text-right">
                    {{'CELL' | translate}}:
                  </div>
                  <div class="col-7 text-left pl-0">
                    {{memberContactInfo.cellPhoneNumber | phone}}
                  </div>
                </div>
              </div>
              <div class="col-2 align-self-center">
                <i *ngIf="member.contact && member.contact.preferredVideoProvider && member.contact.preferredVideoProvider.active"
                  class="fas fa-video pointer" title="{{'OPEN-VIDEOCONFERENCE' | translate}}" style="color: #f5f6fb;"
                  (click)="openVideo(member.contact.preferredVideoProvider.url)"></i>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="card-body bg-light" style="padding: 0.6rem;">
      <div class="row">
        <div class="col">
          <span *ngIf="task?.outcomes?.length > 0 && task?.closedOn === null">
            <span [ngSwitch]="taskCategory?.dropdownoutcome === 'true'">
              <span *ngSwitchCase="true">
                <div ngbDropdown class="d-inline-block text-left" placement="bottom-left" style="padding: 8px 8px;"
                  container="{{dropDownContainer}}">
                  <button class="btn btn-outline-primary k-text-uppercase" id="outcomeChoices"
                    ngbDropdownToggle>{{'OUTCOMES' | translate}}
                  </button>
                  <div ngbDropdownMenu aria-labelledby="outcomeChoices" style="padding:10px">
                    <ng-container *ngFor="let outcome of task.outcomes">
                      <button *ngIf="outcome.color === 'green' && task?.closedOn === null" kendoButton
                        (click)="showTaskCompletionDialog(outcome)" class="btn border-white bg-green" type="button"
                        ngbDropdownItem [disabled]="isDisabledOutcomes">
                        <span *ngIf="outcome.outcome === 'Complete'">{{'COMPLETE' | translate}}</span>
                        <span *ngIf="outcome.outcome !== 'Complete'">{{outcome.outcome}}</span>
                      </button>
                      <button *ngIf="outcome.color === 'red' && task?.closedOn === null" kendoButton
                        (click)="showTaskCompletionDialog(outcome)" class="btn border-white bg-red" type="button"
                        ngbDropdownItem [disabled]="isDisabledOutcomes">
                        <span *ngIf="outcome.outcome === 'Complete'">{{'COMPLETE' | translate}}</span>
                        <span *ngIf="outcome.outcome !== 'Complete'">{{outcome.outcome}}</span>
                      </button>
                      <button *ngIf="outcome.color === 'orange' && task?.closedOn === null" kendoButton
                        (click)="showTaskCompletionDialog(outcome)" class="btn border-white bg-orange" type="button"
                        ngbDropdownItem [disabled]="isDisabledOutcomes">
                        {{outcome.outcome}}
                      </button>
                    </ng-container>
                  </div>
                </div>
              </span>
              <span *ngSwitchCase="false">
                <!-- outcome based actions -->
                <ng-container *ngFor="let outcome of task.outcomes">
                  <ng-container *ngIf="outcome.color === 'green' && task?.closedOn === null">
                    <button kendoButton (click)="showTaskCompletionDialog(outcome)" [disabled]="isDisabledOutcomes"
                      class="btn border-white bg-green ml-3 mt-1 custom-outcome" type="button" data-toggle="dropdown">
                      <span *ngIf="outcome.outcome === 'Complete'">{{'COMPLETE' | translate}}</span>
                      <span *ngIf="outcome.outcome !== 'Complete'">{{outcome.outcome}}</span>
                    </button>
                  </ng-container>
                  <ng-container *ngIf="outcome.color === 'red' && task?.closedOn === null">
                    <button kendoButton (click)="showTaskCompletionDialog(outcome)" [disabled]="isDisabledOutcomes"
                      class="btn border-white bg-red ml-3 mt-1 custom-outcome" type="button" data-toggle="dropdown">
                      <span *ngIf="outcome.outcome === 'Complete'">{{'COMPLETE' | translate}}</span>
                      <span *ngIf="outcome.outcome !== 'Complete'">{{outcome.outcome}}</span>
                    </button>
                  </ng-container>
                  <ng-container *ngIf="outcome.color === 'orange' && task?.closedOn === null">
                    <button kendoButton (click)="showTaskCompletionDialog(outcome)" [disabled]="isDisabledOutcomes"
                      class="btn border-white bg-orange ml-3 mt-1 custom-outcome" type="button" data-toggle="dropdown">
                      {{outcome.outcome}}
                    </button>
                  </ng-container>
                </ng-container>
              </span>
            </span>
          </span>
          <!-- complete task button-->
          <ng-container *ngIf="task?.outcomes?.length === 0 && task?.closedOn === null">
            <button kendoButton (click)="showTaskCompletionDialog({outcome: taskCompleteText})" [disabled]="isDisabledOutcomes"
              class="btn border-white bg-green ml-3 mt-1 custom-outcome" type="button" data-toggle="dropdown">
              {{'COMPLETE' | translate}}
            </button>
          </ng-container>
          <div ngbDropdown class="d-inline-block text-left float-right" style="margin-right:130px;padding: 8px 8px"
            placement="bottom-left" container="{{dropDownContainer}}">
            <button class="btn btn-outline-primary k-text-uppercase ml-2" id="dropdownMoreChoices"
              ngbDropdownToggle>{{'MORE-ACTIONS' | translate}}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownMoreChoices">
              <button *ngIf="task.status === 'Open'" class="dropdown-item k-text-uppercase" (click)="assignToMe()"
                ngbDropdownItem [disabled]="!userInGroupOrCareCoordinator"
                [ngClass]="{'disabled-text':userInGroupOrCareCoordinator === false}">
                <i class="fal fa-user-tag fa-header-nav-icon fa-fw"
                  [ngClass]="{'disabled-text':userInGroupOrCareCoordinator === false}"></i>{{'ASSIGN-TO-ME' | translate
                }}
              </button>
              <button *ngIf="task.status === 'Open'" class="dropdown-item k-text-uppercase"
                (click)="assigneeDialogOpened = true" ngbDropdownItem [disabled]="isCareCoordinator"
                [ngClass]="{'disabled-text':isCareCoordinator}">
                <i class="fal fa-undo fa-header-nav-icon fa-fw"
                  [ngClass]="{'disabled-text':isCareCoordinator}"></i>{{'REASSIGN' | translate }}
              </button>
              <button *ngIf="task.status === 'Open'" class="dropdown-item k-text-uppercase"
                (click)="taskDueDateOpened = true" ngbDropdownItem>
                <i class="fal fa-calendar-edit fa-header-nav-icon fa-fw"></i>{{ 'RESCHEDULE-TASK' | translate }}
              </button>
              <button *ngIf="task.status === 'Open'" class="dropdown-item k-text-uppercase"
                (click)="priorityDialogOpened = true" ngbDropdownItem>
                <i class="fal fa-exclamation-triangle fa-header-nav-icon fa-fw"></i>{{ 'CHANGE-PRIORITY' | translate }}
              </button>
              <button *ngIf="currentUser.role === 'ROLE_OPERATOR' && task.status === 'Open'"
                class="dropdown-item k-text-uppercase" (click)="forceCloseDialogOpened = true" ngbDropdownItem>
                <i class="fal fa-window-close fa-header-nav-icon fa-fw" style="color:gray"></i>{{ 'FORCE-CLOSE' |
                translate }}
              </button>
              <div *ngIf="task.status === 'Open'" class="dropdown-divider"></div>
              <button *ngIf="accessMessages" class="dropdown-item k-text-uppercase" (click)="composeMessage()"
                ngbDropdownItem>
                <i class="fal fa-envelope-open fa-header-nav-icon fa-fw"></i>{{ 'COMPOSE-SECURE-MESSAGE' | translate }}
              </button>
              <div *ngIf="accessMessages" class="dropdown-divider"></div>
              <button class="dropdown-item k-text-uppercase" (click)="copyToClipboard()" ngbDropdownItem>
                <i class="fal fa-copy fa-header-nav-icon fa-fw" style="color:gray"></i>{{ 'COPY' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- task summary -->
    <div class="content-background" [ngClass]="{'pb-0': showDetails}">
      <div class="row align-items-start">
        <div class="col-sm-5">
          <div class="comfort-padding" *ngIf="!task.inCaseDetail && task.caseType">
            <span class="font-weight-bold">{{ 'CASE' | translate }}:</span> {{task.caseType}}
          </div>
          <div class="comfort-padding" *ngIf="task.caseId">
            <span class="font-weight-bold">{{ 'CASE-ID-NUMBER' | translate }}:</span> {{task.caseId}}
          </div>
          <div class="comfort-padding" *ngIf="task?.eventReferral?.referredServiceName">
            <span class="font-weight-bold">{{ 'REFERRED-SERVICE' | translate }}:</span>
            {{task.eventReferral.referredServiceName}}
          </div>
          <div class="comfort-padding" *ngIf="task?.eventReferral?.serviceType">
            <span class="font-weight-bold">{{ 'COMMUNITY-SERVICE-TYPE' | translate }}:</span>
            {{task.eventReferral.serviceType}}
          </div>
          <div class="comfort-padding" *ngIf="task?.eventReferral?.serviceCategory">
            <span class="font-weight-bold">{{ 'COMMUNITY-SERVICE-CATEGORY' | translate }}:</span>
            {{task.eventReferral.serviceCategory}}
          </div>
          <div class="comfort-padding" *ngIf="task?.eventReferral">
            <span class="font-weight-bold">{{ 'REFERRED-FROM' | translate }}:</span>&nbsp;<span
              *ngIf="task.eventReferral?.referredFromName">
              <i class="fas fa-user"></i>&nbsp;{{task.eventReferral?.referredFromName}} <span
                *ngIf="task.eventReferral.referredFromOrganizationName !== null">
                -
                {{task.eventReferral?.referredFromOrganizationName}}</span>
            </span>
          </div>
          <div *ngIf="task?.eventReferral?.referredFromUserEmail" class="row ml-5">
            <div class="col-12 contact-smaller">
              <i class="fas fa-envelope contact-padding"></i>&nbsp;{{ task.eventReferral.referredFromUserEmail}}
            </div>
          </div>
          <div *ngIf="task?.eventReferral?.referredFromUserPhoneNumber" class="row ml-5">
            <div class="col-12 contact-smaller">
              <span>
                <i class="fas fa-phone contact-padding"></i>&nbsp;{{task.eventReferral.referredFromUserPhoneNumber |
                phone}}
              </span>
            </div>
          </div>
          <div *ngIf="task?.eventReferral?.referredToOrganizationName" class="comfort-padding">
            <span class="font-weight-bold">{{ 'REFERRED-TO' | translate }}:</span><i
              class="fas fa-hospital-user ml-1"></i>&nbsp;{{task.eventReferral.referredToOrganizationName}}
          </div>
          <div class="comfort-padding">
            <span class="font-weight-bold">{{ 'TASK-PRIORITY' | translate }}:</span> {{task.priority}}
          </div>
          <div class="comfort-padding">
            <span class="font-weight-bold">{{ 'CREATED-DATE' | translate }}:</span>&nbsp;
            {{task.openedOn | date}} <span>{{task.taskCreatedOnText}}</span>
          </div>
          <div class="comfort-padding" *ngIf="task.dueDate">
            <span class="font-weight-bold">{{ 'TASK-DUE' | translate }}:</span>&nbsp;
            {{task.dueDate | date}} <span>{{task.taskDueOnText}}</span>
          </div>
          <app-task-detail-related-to [taskId]="task.id">
          </app-task-detail-related-to>
          <div class="comfort-padding" *ngIf="task.assigneeName">
            <span class="font-weight-bold">{{'ASSIGNED-TO' | translate}}:</span>&nbsp; {{task.assigneeName}}
          </div>
        </div>
        <div class="col-sm-7" style="overflow: auto;">
          <div class="row">
            <div>
              <div class="text-uppercase font-weight-bold montserrat">
                {{'TASK-DESCRIPTION' | translate}}
              </div>
              <div *ngIf="!taskDescription">
                {{'NO-TASK-DESCRIPTION' | translate}}
              </div>
              <div *ngIf="taskDescription" contenteditable="false" [innerHTML]="taskDescription">
              </div>
              <div *ngIf="assessmentName">
                <div class="text-uppercase font-weight-bold montserrat" [ngClass]="{'mt-3': !taskDescription}">
                  {{'ASSESSMENT' | translate}}
                </div>
                <div>
                  {{assessmentName}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="w-100 mr-3">
              <div class="text-uppercase font-weight-bold montserrat"
                [ngClass]="{'mt-3': !taskDescription || assessmentName}">
                {{'SUPPORTING-DOCUMENTATION' | translate}}
              </div>
              <div *ngIf="supportDocuments.length === 0">{{'NO-DOCUMENTS-FOUND' | translate}}</div>
              <div class="row" *ngFor="let d of supportDocuments">
                <div class="col-8">
                  {{d.name}}
                </div>
                <div class="col-4 text-right">
                  <i *ngIf="d?.url" class="fas fa-download fa-lg" title="{{ 'DOWNLOAD' | translate }}"
                    (click)="saveFileLocal(d['url'], d['name'])">
                  </i>
                  &nbsp;
                  <i *ngIf="d?.url" class="fas fa-eye fa-lg" title="{{ 'VIEW' | translate }}"
                    (click)="viewHandler(d['url'], d['name'], d['mimeType'], d['date'])">
                  </i>
                  &nbsp;
                  <i *ngIf="d.url" class="fas fa-envelope fa-send-document-action fa-lg pointer"
                    title="{{ 'SEND-DOCUMENT' | translate }}" (click)="onSendDocument(d['url'], d['name'])">
                  </i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h6 class="details" *ngIf="!showDetails">
        <span class="ml-3 mr-3 montserrat keyboard-accessible" role="button" (click)="showDetails = true" tabindex="0"
          (keydown.enter)="showDetails = true" (keydown.space)="showDetails = true">
          <i class="fal fa-angle-down mr-2" aria-hidden="true"></i>
          {{'VIEW-DETAILS' | translate}}
        </span>
      </h6>
      <h6 class="details" *ngIf="showDetails">
        <span class="ml-3 mr-3 montserrat keyboard-accessible" (click)="showDetails = false" tabindex="0"
          (keydown.enter)="showDetails = false" (keydown.space)="showDetails = false">
          <i class="fal fa-angle-up mr-2" aria-hidden="true"></i>
          {{'HIDE-DETAILS' | translate}}
        </span>
      </h6>
    </div>
    <div class="content-background pt-0" [ngClass]="{'content-max-height': task.inCaseDetail || task.inMemberDetail}"
      *ngIf="showDetails">
      <div class="row align-items-start">
        <div [ngClass]="{'col-sm-6': !isReferralCoordinator || attachmentsEnabled, 'col-sm-12 ': isReferralCoordinator && !attachmentsEnabled,
         'mb-3' : isReferralCoordinator }">
          <div class="text-uppercase font-weight-bold montserrat">
            {{'TASK-NOTES' | translate}}
          </div>
          <div>
            <kendo-editor class="html-editor" [iframe]="false" [(ngModel)]="taskDetails.note" [updateInterval]="1000"
              *ngIf="taskDetails" [value]="taskDetails?.note" (valueChange)="noteChange($event)">
              <kendo-toolbar [overflow]="true" style="display:block">
                <kendo-toolbar-buttongroup>
                  <kendo-toolbar-button kendoEditorBoldButton></kendo-toolbar-button>
                  <kendo-toolbar-button kendoEditorItalicButton></kendo-toolbar-button>
                  <kendo-toolbar-button kendoEditorUnderlineButton></kendo-toolbar-button>
                  <kendo-toolbar-button kendoEditorStrikethroughButton></kendo-toolbar-button>
                </kendo-toolbar-buttongroup>
                <kendo-toolbar-buttongroup>
                  <kendo-toolbar-button kendoEditorAlignLeftButton></kendo-toolbar-button>
                  <kendo-toolbar-button kendoEditorAlignCenterButton></kendo-toolbar-button>
                  <kendo-toolbar-button kendoEditorAlignRightButton></kendo-toolbar-button>
                  <kendo-toolbar-button kendoEditorAlignJustifyButton></kendo-toolbar-button>
                </kendo-toolbar-buttongroup>
                <kendo-toolbar-buttongroup>
                  <kendo-toolbar-button kendoEditorInsertUnorderedListButton></kendo-toolbar-button>
                  <kendo-toolbar-button kendoEditorInsertOrderedListButton></kendo-toolbar-button>
                  <kendo-toolbar-button kendoEditorIndentButton></kendo-toolbar-button>
                  <kendo-toolbar-button kendoEditorOutdentButton></kendo-toolbar-button>
                </kendo-toolbar-buttongroup>
                <kendo-toolbar-colorpicker kendoEditorForeColor></kendo-toolbar-colorpicker>
                <kendo-toolbar-colorpicker kendoEditorBackColor></kendo-toolbar-colorpicker>
                <kendo-toolbar-dropdownlist kendoEditorFormat></kendo-toolbar-dropdownlist>
                <kendo-toolbar-dropdownlist kendoEditorFontSize></kendo-toolbar-dropdownlist>
                <kendo-toolbar-button kendoEditorCleanFormattingButton></kendo-toolbar-button>
              </kendo-toolbar>
            </kendo-editor>
          </div>
          <div *ngIf="!isReferralCoordinator && member">
            <div class="row mr-4 mt-2">
              <div class="col">
                <div class="text-uppercase font-weight-bold montserrat">
                  {{ 'TASK-DETAILS-ENROLL-TO-CHANNEL' | translate:patientLabel }}
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-7">
                <div hidden id="enrollPatient">
                  {{ 'TASK-DETAILS-ENROLL-TO-CHANNEL' | translate:patientLabel }}
                </div>
                <kendo-combobox class="w-100" id="notEnrolledChannelsDropdown" [data]="groupedChannels"
                  [textField]="'name'" [valueField]="'id'" [filterable]="true"
                  (filterChange)="filterNotEnrolledChannels($event)" (close)="searchTerm=''"
                  [(ngModel)]="channelToEnroll" [attr.aria-labelledby]="'enrollPatient'"></kendo-combobox>
              </label>
              <div class="col-4 text-left">
                <button appPreventClick kendoButton type="button" [disabled]="channelToEnroll === undefined"
                  (click)="caseDialogOpened = true">
                  {{ 'ENROLL' | translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <!--Task attachments-->
          <div *ngIf="attachmentsEnabled">
            <div class="text-uppercase font-weight-bold montserrat">
              {{'ATTACHMENTS' | translate}}
            </div>
            <div style="max-height: 120px; overflow-y: auto; overflow-x: hidden;" class="pr-1">
              <app-document [memberId]="task.memberId" [member]="member" [caseId]="" [taskId]="task.id"
                [assessmentTaskId]="taskDetails.assessmentTaskId !== null ? taskDetails.assessmentTaskId : 0"
                [taskDefinitionId]="" [bpmId]="" [messageId]="" [allowAdd]="task.status === 'Open'"
                [allowSendCaptureLink]="true" (uploadedDocument)="documentModified()"
                (deletedDocument)="documentModified()">
              </app-document>
            </div>
          </div>
          <!--Followup/Related Tasks-->
          <div *ngIf="!isReferralCoordinator">
            <div class="text-uppercase font-weight-bold montserrat pt-2">
              {{'TASK-DETAILS-FOLLOWUP-RELATED-TASK' | translate}}
            </div>
            <div class="pr-1">
              <app-task-detail-followup-list [taskId]="task.id" [memberId]="task.memberId" [caseId]="task.caseId"
                [channelId]="task.channelId" (followUpTaskAdded)="followUpTaskAdded()">
              </app-task-detail-followup-list>
            </div>
          </div>
        </div>
      </div>
      <!-- task history table -->
      <kendo-grid [data]="view.gridData" [pageSize]="view.state.take" [skip]="view.state.skip" [sortable]="true"
        [sort]="view.state.sort" [pageable]="{buttonCount: 5, pageSizes: pageSizes}" [navigable]="true"
        (dataStateChange)="dataStateChange($event)">
        <kendo-grid-column field="time" title="{{'DATE' | translate}}" [width]="20" filter="date" format="{0:d}">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span>{{intl.formatDate(intl.parseDate(dataItem.time), "g")}}</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="content" title="{{'TASK-HISTORY' | translate}}" [width]="60"></kendo-grid-column>
        <kendo-grid-column field="createdBy" title="{{'CREATOR' | translate}}" [width]="20"></kendo-grid-column>
      </kendo-grid>
    </div>
  </div>
</div>

<!-- reassign task dialog -->
<app-task-assign [task]="task" [dialogOpened]="assigneeDialogOpened" (closing)="closeTaskAssigneeDialog();"
  (save)="updateTaskAssignee($event)">
</app-task-assign>

<!-- force close task dialog -->
<app-task-force-close [task]="task" [dialogOpened]="forceCloseDialogOpened" (closing)="closeForceCloseDialog();"
  (save)="forceClose()">
</app-task-force-close>

<!-- duedate task dialog -->
<app-task-duedate [task]="task" [dialogOpened]="taskDueDateOpened" (closing)="closeTaskDueDateDialog()"
  (save)="updateTaskDueDate($event)">
</app-task-duedate>

<!-- reassign task dialog -->
<app-task-priority [task]="task" [dialogOpened]="priorityDialogOpened" (closing)="closeTaskPriorityDialog();"
  (save)="updateTaskPriority($event)">
</app-task-priority>

<!-- complete task confirmation dialog -->
<kendo-dialog *ngIf="completeTaskDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
  (close)="closeCompleteDialog()">
  {{'CONFIRM-COMPLETE-TASK' | translate}}
  <div *ngIf="selectedOutcome && selectedOutcome.outcome" class="k-font-weight-bold mt-2">{{selectedOutcome.outcome}}
  </div>
  <kendo-dialog-actions>
    <button [disabled]="completingTask" kendoButton (click)="closeCompleteDialog()">{{'NO' | translate}}</button>
    <button [disabled]="completingTask" appPreventClick kendoButton (click)="completeTask(selectedOutcome)">{{'YES' | translate}}</button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- record contact history dialog dialog -->
<app-contact-history #contactHistory [contactHistoryDialogOpened]="contactHistoryDialogOpened" [contact]=""
  [taskId]="task.id" [memberId]="task.memberId" [outcome]="selectedOutcome" [contactCodeset]="contactCodeset"
  [initiativeCodeset]="initiativeCodeset" [areaCodeset]="areaCodeset" (added)="onContactHistoryAdded()"
  (cancelling)="cancelContactHistory()">
</app-contact-history>

<!--Add Assessment dialog-->
<app-member-assessment-add (cancelling)="assessmentDialogOpened=false;" [memberId]="task.memberId" [taskId]="task.id"
  [assessmentId]="assessmentId" [caseId]="task.caseId" [dialogOpened]="assessmentDialogOpened"
  (save)="afterAssessmentFulfillmentAdded($event)">
</app-member-assessment-add>

<!--Document viewer only-->
<app-document [viewerOnly]="true" #documentComponentViewer></app-document>

<app-send-document [memberId]="task.memberId" [caseId]="task.caseId" [documentUrl]="documentUrl"
  [documentName]="documentName" #sendEmail>
</app-send-document>

<app-referral [context]="'task'" *ngIf="task !== undefined && task.memberId !== null && task.memberId > 0"
  [memberId]="task.memberId" (afterReferralProcessing)="afterReferralProcessing()" #referral>
</app-referral>

<app-case-enrollment *ngIf="caseDialogOpened && member !== undefined" [member]="member" [channel]="channelToEnroll"
  (cancelling)="cancelledCaseEnrollment()" (refresh)="getChannelsData()">
</app-case-enrollment>

<!--Services Provided-->
<app-task-detail-services-provided [servicesProvidedDialogOpened]="servicesProvidedDialogOpened" [taskId]="task.id"
  [memberId]="task.memberId" [caseId]="task.caseId" [outcome]="selectedOutcome" [feeScheduleId]="feeScheduleId"
  [feeCategoryId]="feeCategoryId" [checkAccumulatorOnly]="checkAccumulatorOnly" (added)="onServicesProvidedAdded()"
  (cancelling)="cancelServicesProvided()">
</app-task-detail-services-provided>

<!-- message dialog-->
<kendo-dialog *ngIf="messageDialogOpened" (close)="messageDialogOpened=false" [minWidth]="400" [width]="700">
  <kendo-dialog-titlebar>
    <h3>{{ 'NEW-MESSAGE' | translate}}</h3>
  </kendo-dialog-titlebar>
  <app-message-compose #messageCompose [messageDialogOpened]="messageDialogOpened" [memberId]="member.id"
    [caseId]="aTask.caseId" [messageList]="" [fromMessagesScreen]="'member'" [sendTo]="messageSendTo"
    (afterSave)="messageDialogOpened = false;" (saving)="savingMessage=$event;messageDialogOpened=false">
  </app-message-compose>
  <kendo-dialog-actions>
    <button kendoButton (click)="messageDialogOpened = false" [disabled]="savingMessage">{{ 'CANCEL' | translate
      }}</button>
    <button appPreventClick #submitButton kendoButton type="button"
      [disabled]="!messageCompose.formValid() || savingMessage" (click)="messageCompose.save($event);">
      {{'SEND' | translate}}<i class="fal fa-paper-plane"></i>
    </button>
  </kendo-dialog-actions>
</kendo-dialog>